/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useStore } from "../Context";
import Navigation from "../components/Navigation/Navigation";
import PDFViewer from "../components/PDF/PDFViewer";
import signs from '../services/signs';
import fileDownload from 'js-file-download';
import useTheme from '../hooks/useTheme';
import loanlogs from "../services/loanlogs";

function Contract() {
    const { stepForward, contracts } = useStore();
    const [index, setIndex] = useState(0);
    const [url, setURL] = useState()
    
    const theme = useTheme()
    
    const isInformative = contracts[index].informative === 1;

    function getContractsLength() {
        // if(theme === 'cuota-ya') return 4
        return contracts.length
    }

    function downloadPDF () {
        const contract = contracts[index]
        signs.getPDF(contract)
            .then(data => fileDownload(data, `${contract.pdfId}.pdf`))
    };
    
    function nextContract() {
        if(theme === 'cuota-ya' && index + 1 === contracts.length) return
        if(index + 1 === contracts.length) return
        setIndex(index + 1)
    }

    function previousContract() {
        if(index - 1 < 0) return
        setIndex(index - 1)
    }

    useEffect(() => {
        const contract = contracts[index]
        const url = signs.endpointPDF(contract.id, contract.pdfId)
        loanlogs.success('/contracts', { params: { requestFileId: contract.id, pdfId: contract.pdfId }, response: { url } }).catch(console.log)
        setURL(url)
    }, [index])

    return (
        <main className="page-step page-step-contract">
            <Navigation />
            <header className='page-header'>
                <h1>Revisá tu contrato</h1>
                {isInformative && <p>Este documento es solo informativo.</p>}
            </header>
            <div className="page-content">
                <PDFViewer url={url} />
            </div>
            <div className="page-actions flex-column">
                <div className="flex-row flex-justify-center">
                    <button className="button-transparent" onClick={previousContract}>
                        <img src={`/${theme}/icon-arrow-left.svg`} alt="" width="25"/>
                    </button>
                    <span className="text-base">
                        {index + 1}/{getContractsLength()}
                    </span>
                    <button className="button-transparent" onClick={nextContract}>
                        <img src={`/${theme}/icon-arrow-right.svg`} alt="" width="25" />
                    </button>
                </div>
                <button className="button-primary" onClick={stepForward}>
                    Firma electrónica
                </button>
                <button className="button-secondary" onClick={downloadPDF}>
                    <img src={`/${theme}/icon-download.svg`} alt="" className='icon' />
                    Descargar
                </button>
            </div>
        </main>
    );
}

export default Contract;
